import React from "react";

import Landing from "./pages/Landing";
const Blog = () => {
    return (
        <div>
            <Landing />
        </div>
    );
};

export default Blog;
